

// const apiUrl = "http://206.189.134.171:8000"

export const apiUrl = "https://api.greenmarkindia.com"